'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _RelationshipModel = require('../model/RelationshipModel');

var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);

var _RelationshipForm = require('../ui/RelationshipForm');

var _RelationshipForm2 = _interopRequireDefault(_RelationshipForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditRelationship = function EditRelationship(element, args) {
  var _this = this;

  _classCallCheck(this, EditRelationship);

  this.onchange = function () {
    _this.data = _this.relationshipForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('relationships', _this.data.getJSON()).then(function (relationship) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && relationship.id) {
        window.PRIM.navigate('/relationships/' + relationship.id, true);
      }

      if (relationship) {
        _this.data.values.id = relationship.id;
        _this.relationshipForm.setValue(_this.data);
      }
    });
  };

  this.data = new _RelationshipModel2.default();

  if (args) {
    if (args.id) {
      window.PRIM.dataAccess.resolve('relationships', args.id, true).then(function (relationship) {
        _this.data = relationship;
        _this.relationshipForm.setValue(_this.data);
      }, function () {
        if (confirm('Deze relatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw relatie aanmaken?')) {
          window.PRIM.navigate('/relationships/');
        } else {
          history.back();
        }
      }).catch(function () {
        alert('Fout');
      });
    } else if (args.person_id) {
      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
        _this.data.values.person_id = person.values.id;
        _this.data.person = person;
        _this.relationshipForm.setValue(_this.data);
      });
    }
  }

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Relatie bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze relatie wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('relationships', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze relatie.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  this.relationshipForm = new _RelationshipForm2.default(divContent, { relationship: this.data, onchange: this.onchange });

  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditRelationship;


//////////////////
// WEBPACK FOOTER
// ./js/modules/relationship/action/EditRelationship.js
// module id = 70
// module chunks = 0